import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { request, sleep } from "@/js/http/http_request";
import { orderStatus, getOrderStatusLabel, orderTypes, paymentState, expeditionMethods } from "@/js/lists.ts";
import { userIsIndividual, getFullNameUserHtml } from "@/js/user/user.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { regexbAbsoluteUri } from "@/js/regexp_validation.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import MailTemplateForm from "@/components/mail/MailTemplateForm.vue";
import MailTemplateModal from "@/components/mail/MailTemplateModal.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import OrderShipmentList from "@/components/order/AdminSummarySubs/OrderShipmentsList.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  components: {
    Confirm: Confirm,
    MailTemplateModal: MailTemplateModal,
    MailTemplateForm: MailTemplateForm,
    OrderShipmentList: OrderShipmentList,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    isShown: false,
    dialog: Boolean,
    order: {
      type: Object,
      default: {}
    },
    orderChildren: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      URL: URL,
      drawerWidth: null,
      documents: [],
      subordersTableHeaders: [{
        text: "Order",
        value: "reference",
        align: "left"
      }, {
        text: "Important data",
        value: "orderData",
        align: "left"
      }, {
        text: "Customer",
        value: "user",
        align: "left"
      }, {
        text: "Delivery",
        value: "deliveryAddress",
        align: "left"
      }, {
        text: "Amount",
        value: "amount",
        align: "center",
        cellCss: "text-nowrap"
      }, {
        text: "NbBottles",
        value: "quantity",
        align: "center"
      }],
      isSuccessfulSending: {},
      hasFailedSending: false,
      failedCustomMails: {},
      isLoadingFiles: false,
      isSyncing: false,
      isNeedingSync: false,
      isDeletingTemplate: false,
      templateModalShown: false,
      editableTemplate: {},
      drawer: false,
      panels: [],
      openedPanel: 0,
      emailPlaceholders: {},
      emailTemplates: [],
      form: {
        slots: {},
        emailTemplates: [{
          id: 0,
          sendTo: [],
          files: [],
          mailHistories: []
        }],
        notificationStorage: {}
      },
      isSendNotificationMails: true,
      preventNotifyCustomer: false,
      availableOrders: [],
      steps: [],
      defaultSteps: [],
      currentStep: 1,
      ttbStepTip: null,
      slots: [],
      isValidatingOrder: false,
      isFillingNewCarrier: false,
      isDeletingCarrier: [],
      isCreatingCarrier: false,
      isCheckingTtb: false,
      isStatelessDrawer: true,
      errorOccurred: false,
      interval: null,
      expeditionMethods: expeditionMethods,
      rules: formRules,
      orderStatus: orderStatus,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isGreatExport: function isGreatExport() {
      var _this$order;
      return !((_this$order = this.order) !== null && _this$order !== void 0 && (_this$order = _this$order.delivery_address) !== null && _this$order !== void 0 && (_this$order = _this$order.country) !== null && _this$order !== void 0 && _this$order.european_union_member);
    },
    defaultDrawerWidth: function defaultDrawerWidth() {
      if (this.isContainerOrder) {
        return "80%";
      } else {
        return "45%";
      }
    },
    isContainerOrder: function isContainerOrder() {
      var _this$order2;
      return ((_this$order2 = this.order) === null || _this$order2 === void 0 ? void 0 : _this$order2.type) === orderTypes.CONTAINER;
    },
    isContainerOrderWithAnySuborderNotValidated: function isContainerOrderWithAnySuborderNotValidated() {
      var _this$order$container;
      var forbiddenStatus = [orderStatus.find(function (x) {
        return x.id == "AWAITING_VALIDATION";
      }).status, orderStatus.find(function (x) {
        return x.id == "AWAITING_CUSTOMER_VALIDATION";
      }).status, orderStatus.find(function (x) {
        return x.id == "ADJUSTING";
      }).status, orderStatus.find(function (x) {
        return x.id == "ON_HOLD";
      }).status];
      return this.isContainerOrder && ((_this$order$container = this.order.containerSubOrders) === null || _this$order$container === void 0 ? void 0 : _this$order$container.some(function (x) {
        return forbiddenStatus.includes(x.status);
      }));
    },
    isContainerOrderWithAnySuborderNotFullyCalculated: function isContainerOrderWithAnySuborderNotFullyCalculated() {
      var _this$order$container2;
      return this.isContainerOrder && ((_this$order$container2 = this.order.containerSubOrders) === null || _this$order$container2 === void 0 ? void 0 : _this$order$container2.some(function (x) {
        return !x.isFullyCalculatedAmounts;
      }));
    },
    isContainerOrderWithAnySuborderPricePostingNotMatch: function isContainerOrderWithAnySuborderPricePostingNotMatch() {
      var _this$order$pricePost,
        _this$order$container3,
        _this2 = this;
      return this.isContainerOrder && ((_this$order$pricePost = this.order.pricePostingUsaPro) === null || _this$order$pricePost === void 0 ? void 0 : _this$order$pricePost.id) > 0 && ((_this$order$container3 = this.order.containerSubOrders) === null || _this$order$container3 === void 0 ? void 0 : _this$order$container3.some(function (x) {
        var _x$pricePostingUsaPro, _x$pricePostingUsaPro2;
        return ((_x$pricePostingUsaPro = x.pricePostingUsaPro) === null || _x$pricePostingUsaPro === void 0 ? void 0 : _x$pricePostingUsaPro.id) > 0 && ((_x$pricePostingUsaPro2 = x.pricePostingUsaPro) === null || _x$pricePostingUsaPro2 === void 0 ? void 0 : _x$pricePostingUsaPro2.id) != _this2.order.pricePostingUsaPro.id;
      }));
    },
    hasParentContainerBeforeMerge: function hasParentContainerBeforeMerge() {
      var _this$order3;
      return ((_this$order3 = this.order) === null || _this$order3 === void 0 || (_this$order3 = _this$order3.parentContainerOrder) === null || _this$order3 === void 0 ? void 0 : _this$order3.id_order) > 0 && this.order.parentContainerOrder.isContainerOrderBeforeMerge;
    },
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        var _x$sendTo;
        return !x.id || !x.from || !((_x$sendTo = x.sendTo) !== null && _x$sendTo !== void 0 && _x$sendTo.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
      };
      if (this.form.emailTemplates.some(nullishPredicate)) return true;
      if (this.isContainerOrderWithAnySuborderNotValidated) {
        return true;
      }
      if (this.isContainerOrderWithAnySuborderNotFullyCalculated) {
        return true;
      }
      return false;
    },
    errorsForm: function errorsForm() {
      if (this.isInvalidForm) {
        var errors = [];
        var nullishPredicate = function nullishPredicate(x) {
          var _x$sendTo2;
          return !x.id || !x.from || !((_x$sendTo2 = x.sendTo) !== null && _x$sendTo2 !== void 0 && _x$sendTo2.length) || !x.subject || !x.htmlContent.replace(/<[^>]*>?/gm, "");
        };
        if (this.form.emailTemplates.some(nullishPredicate)) errors.push("At least one mail configured is still not set correctly. You should delete it, or configure it completely.");
        return errors;
      }
      return null;
    },
    flattenPlaceholders: function flattenPlaceholders() {
      return Object.values(this.emailPlaceholders).flat();
    }
  },
  watch: {
    isShown: function isShown(visible) {
      this.drawer = visible;
      this.closureAttempt = 0;
      if (visible) {
        if (!this.defaultSteps.length) {
          this.defaultSteps = _toConsumableArray(this.steps.map(function (x) {
            return _objectSpread({}, x);
          }));
        }
        this.initStep();
        this.fetchEmailPlaceholders();
        this.fetchEmailTemplates();
        this.fetchOrderDocuments();
        if (!this.isGreatExport) {
          this.form.emailTemplates = [];
        }
      }
    },
    currentStep: function currentStep(_currentStep) {
      if (this.steps.length > 0 && _currentStep === this.steps.find(function (x) {
        return x.key === "mail";
      }).id) {
        this.drawerWidth = "80%";
      } else {
        this.drawerWidth = this.defaultDrawerWidth;
      }
    }
  },
  updated: function updated() {
    this.closureAttempt++;
  },
  created: function created() {
    this.drawerWidth = this.defaultDrawerWidth;
  },
  methods: {
    changePanel: function changePanel() {
      var _this3 = this;
      if (document.querySelector("#expansion-panel_".concat(this.openedPanel && this.openedPanel - 1))) {
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(_this3.openedPanel && _this3.openedPanel - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      }
    },
    deleteTemplatePanel: function deleteTemplatePanel(index) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.$refs.confirm.open("Confirm", "Are you sure you want to delete the configuration of this e-mail?");
            case 2:
              isConfirmed = _context.sent;
              if (isConfirmed) {
                _this4.form.emailTemplates.splice(index, 1);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    syncLatestVersion: function syncLatestVersion() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var selectedTemplate, current;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.isSyncing = true;
              _context2.next = 3;
              return _this5.fetchEmailTemplates();
            case 3:
              selectedTemplate = _this5.form.emailTemplates[_this5.openedPanel];
              if (!!selectedTemplate.id) {
                current = _this5.emailTemplates.find(function (x) {
                  return x.id === selectedTemplate.id;
                });
                _this5.changeTemplate(current);
              }
              _this5.isSyncing = false;
              _this5.isNeedingSync = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    replaceSymbol: function replaceSymbol(value) {
      var _this$flattenPlacehol;
      return ((_this$flattenPlacehol = this.flattenPlaceholders.find(function (x) {
        return x.symbol === value;
      })) === null || _this$flattenPlacehol === void 0 ? void 0 : _this$flattenPlacehol.filledValue) || "";
    },
    closeTemplateModal: function closeTemplateModal() {
      var _this6 = this;
      this.editableTemplate = {};
      this.$nextTick(function () {
        return _this6.templateModalShown = false;
      });
    },
    newTemplate: function newTemplate() {
      var _this7 = this;
      this.$nextTick(function () {
        return _this7.templateModalShown = true;
      });
    },
    clickPlaceholder: function clickPlaceholder(item, callback) {
      callback(this.replaceSymbol(item.symbol));
    },
    saveTemplate: function saveTemplate(template, success, fail) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this8;
              _context3.next = 3;
              return request("/v1/mail/templates", !!template.id ? "put" : "post", template, true, "api").catch(function (e) {
                var _e$response$data;
                if ((_e$response$data = e.response.data) !== null && _e$response$data !== void 0 && _e$response$data.value) {
                  _this.$toasted.show(e.response.data.value, {
                    type: "error"
                  });
                } else {
                  _this.$toasted.show("Unable to save the new template.", {
                    type: "error"
                  });
                }
                fail();
                throw e;
              });
            case 3:
              _this8.$toasted.show("Template saved.", {
                type: "success"
              });
              if (!!template.id) _this8.isNeedingSync = true;else _this8.fetchEmailTemplates();
              success();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    deleteTemplate: function deleteTemplate(templateId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var isConfirmed, _this, rest;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this9.$refs.confirm.open("Confirm", "Are you sure you want to remove it permanently?");
            case 2:
              isConfirmed = _context4.sent;
              if (!isConfirmed) {
                _context4.next = 14;
                break;
              }
              _this9.isDeletingTemplate = true;
              _this = _this9;
              _context4.next = 8;
              return request("/v1/mail/templates/".concat(templateId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to delete this template.", {
                  type: "error"
                });
                _this.isDeletingTemplate = false;
                throw e;
              });
            case 8:
              _context4.next = 10;
              return _this9.fetchEmailTemplates();
            case 10:
              rest = _this9.form.emailTemplates.filter(function (x) {
                return x.id !== templateId;
              });
              _this9.form.emailTemplates = _toConsumableArray(rest.length > 0 ? rest : [{
                id: 0,
                files: [],
                sendTo: [],
                mailHistories: []
              }]);
              _this9.editableTemplate = {};
              _this9.isDeletingTemplate = false;
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    editTemplate: function editTemplate(id) {
      this.templateModalShown = true;
      var template = this.emailTemplates.find(function (x) {
        return x.id === id;
      });
      this.editableTemplate = _objectSpread({}, template);
    },
    fetchEmailTemplates: function fetchEmailTemplates() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this10;
              _context5.next = 3;
              return request("/v1/mail/templates", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to fetch email templates.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context5.sent;
              _this10.emailTemplates = _toConsumableArray(response.data).map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  files: [],
                  sendTo: []
                });
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchEmailPlaceholders: function fetchEmailPlaceholders() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return request("/v1/mail/placeholders?orderId=".concat(_this11.order.id_order), "get", null, true, "api");
            case 2:
              response = _context6.sent;
              _this11.emailPlaceholders = response.data;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    clickOutsideDrawer: function clickOutsideDrawer() {
      this.drawer = this.isStatelessDrawer && this.isShown;
    },
    newEmail: function newEmail() {
      var _this12 = this;
      this.form.emailTemplates = [].concat(_toConsumableArray(this.form.emailTemplates), [{
        id: 0,
        sendTo: [],
        files: [],
        mailHistories: []
      }]);
      this.$nextTick(function () {
        var i = _this12.form.emailTemplates.length - 1;
        _this12.openedPanel = i;
        setTimeout(function () {
          document.querySelector("#expansion-panel_".concat(i && i - 1)).scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 400);
      });
    },
    changeTemplate: function changeTemplate(item) {
      var reduce = function reduce(acc, x) {
        return acc.replaceAll(x.symbol, x.filledValue);
      };
      this.form.emailTemplates.splice(this.openedPanel, 1, _objectSpread(_objectSpread({}, item), {}, {
        subject: this.flattenPlaceholders.reduce(reduce, item.subject),
        htmlContent: this.flattenPlaceholders.reduce(reduce, item.htmlContent)
      }));
    },
    close: function close() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var isConfirmed;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              isConfirmed = true;
              if (_this13.hasFailedSending) {
                _context7.next = 5;
                break;
              }
              _context7.next = 4;
              return _this13.$refs.confirm.open("Cancel", "Are you sure you want to cancel the shipment ?");
            case 4:
              isConfirmed = _context7.sent;
            case 5:
              if (isConfirmed) {
                _this13.currentStep = 1;
                _this13.steps = _toConsumableArray(_this13.defaultSteps.map(function (x) {
                  return _objectSpread({}, x);
                }));
                _this13.isStatelessDrawer = false;
                _this13.drawer = false;
                _this13.$emit("close", true);
                _this13.isStatelessDrawer = true;
              }
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    acknowledgeValidation: function acknowledgeValidation() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this14.$emit("validate", true, function () {
                if (!_this14.hasFailedSending) _this14.$emit("close", true);
                _this14.isValidatingOrder = false;
                _this14.$toasted.show("Order has been succesfully put in delivery.", {
                  type: "success"
                });
              });
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    validateMain: function validateMain() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var isConfirmed, _this, _loop, i;
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this15.$refs.confirm.open("Order shipment", "Are you sure the order is shipped ?");
            case 2:
              isConfirmed = _context12.sent;
              if (!isConfirmed) {
                _context12.next = 17;
                break;
              }
              _this = _this15;
              _this15.isValidatingOrder = true;
              _context12.next = 8;
              return _this15.putOrder(_this15.order, {
                send_mails: _this15.isSendNotificationMails,
                preventNotifyCustomer: _this15.preventNotifyCustomer
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to put the order in delivery.", true);
                handleErrorData(_this, errorData);
                _this.isValidatingOrder = false;
                throw e;
              });
            case 8:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var template, formData, _this;
                return _regeneratorRuntime().wrap(function _loop$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      template = _this15.form.emailTemplates[i];
                      template.templateId = template.id;
                      formData = new FormData();
                      Object.keys(template).forEach(function (key) {
                        return formData.append(key, template[key]);
                      });
                      template.files.forEach(function (x) {
                        formData.append("files", !x.blob ? x : new File([x.blob], x.id));
                      });
                      _this = _this15;
                      _context11.next = 8;
                      return request("/v1/mail/send", "post", formData, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                          while (1) switch (_context9.prev = _context9.next) {
                            case 0:
                              _this.isSuccessfulSending = _objectSpread(_objectSpread({}, _this.isSuccessfulSending), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                              _context9.next = 3;
                              return sleep(100);
                            case 3:
                            case "end":
                              return _context9.stop();
                          }
                        }, _callee9);
                      }))).catch(/*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
                          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                            while (1) switch (_context10.prev = _context10.next) {
                              case 0:
                                _this.hasFailedSending = true;
                                _this.failedCustomMails = _objectSpread(_objectSpread({}, _this.failedCustomMails), {}, _defineProperty({}, "".concat(template.id, "_").concat(i), true));
                                _context10.next = 4;
                                return sleep(100);
                              case 4:
                              case "end":
                                return _context10.stop();
                            }
                          }, _callee10);
                        }));
                        return function (_x) {
                          return _ref2.apply(this, arguments);
                        };
                      }());
                    case 8:
                    case "end":
                      return _context11.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 10:
              if (!(i < _this15.form.emailTemplates.length)) {
                _context12.next = 15;
                break;
              }
              return _context12.delegateYield(_loop(i), "t0", 12);
            case 12:
              i++;
              _context12.next = 10;
              break;
            case 15:
              _this.$emit("stateOrderUpdated");
              _this15.acknowledgeValidation();
            case 17:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    putOrder: function putOrder(order, body) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", request("/v1/order/" + order.id_order + "/state/" + orderStatus.find(function (os) {
                return os.id === "DELIVERY";
              }).status, "put", body, true, "api"));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this16.isLoadingFiles = true;
              _this = _this16;
              _context14.next = 4;
              return request("/v1/orders/" + _this16.order.id_order + "/docs", "get", null, true, "api").catch(function (e) {
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context14.sent;
              _this16.documents = response.data.reduce(function (acc, x) {
                return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                  children: _toConsumableArray(x.document_urls)
                })]);
              }, []);
              _this16.isLoadingFiles = false;
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    initStep: function initStep() {
      var stepCount = 1;
      if (this.isContainerOrder) {
        this.steps = [].concat(_toConsumableArray(this.steps), [{
          id: stepCount,
          key: "containerSuborders",
          title: "Container suborders",
          inf: "Every suborders must have been validated"
        }]);
        stepCount++;
      }
      this.steps = [].concat(_toConsumableArray(this.steps), [{
        id: stepCount,
        key: "shipment",
        title: "Shipments",
        inf: "Fill in the shipments information"
      }, {
        id: stepCount + 1,
        key: "mail",
        title: "Send custom e-mail(s)",
        inf: "Select an email template and targets to inform stakeholders."
      }, {
        id: stepCount + 2,
        key: "synthesis",
        title: "Synthesis",
        data: this.availableOrders.reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.id_order, x));
        }, {})
      }]);
    },
    confirmStep: function confirmStep() {
      this.currentStep++;
    },
    shipmentsChanged: function shipmentsChanged(shipments) {
      var trackedShip = null;
      if ((shipments === null || shipments === void 0 ? void 0 : shipments.length) > 0) {
        trackedShip = shipments.find(function (x) {
          return x.tracked;
        }) || shipments[shipments.length - 1];
      }
      this.trackingNumberChanged(trackedShip);
      this.trackingUrlChanged(trackedShip);
      this.carrierNameChanged(trackedShip);
    },
    trackingNumberChanged: function trackingNumberChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "TrackingNumber";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber)) {
        var _shipment$trackingNum;
        placeholder.filledValue = (_shipment$trackingNum = shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber) !== null && _shipment$trackingNum !== void 0 ? _shipment$trackingNum : "";
        this.trackingChanged(shipment);
      }
    },
    trackingUrlChanged: function trackingUrlChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "TrackingUrl";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink)) {
        var _shipment$trackingLin;
        placeholder.filledValue = (_shipment$trackingLin = shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink) !== null && _shipment$trackingLin !== void 0 ? _shipment$trackingLin : "";
        this.trackingChanged(shipment);
      }
    },
    trackingChanged: function trackingChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "Tracking";
      });
      var value = "";
      if (!!(shipment !== null && shipment !== void 0 && shipment.trackingNumber)) {
        if (regexbAbsoluteUri.test(shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink)) {
          value = '<a href="' + (shipment === null || shipment === void 0 ? void 0 : shipment.trackingLink) + '">' + (shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber) + "</a>";
        } else {
          value = shipment === null || shipment === void 0 ? void 0 : shipment.trackingNumber;
        }
      }
      placeholder.filledValue = value;
    },
    carrierNameChanged: function carrierNameChanged(shipment) {
      var placeholder = this.emailPlaceholders.Order.find(function (x) {
        return x.name === "CarrierName";
      });
      if (placeholder.filledValue != (shipment === null || shipment === void 0 ? void 0 : shipment.carrierName)) {
        var _shipment$carrierName;
        placeholder.filledValue = (_shipment$carrierName = shipment === null || shipment === void 0 ? void 0 : shipment.carrierName) !== null && _shipment$carrierName !== void 0 ? _shipment$carrierName : "";
      }
    },
    orderDetails: function orderDetails(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    isIndiviualAndNotPaid: function isIndiviualAndNotPaid(order) {
      return userIsIndividual(order.user) && order.paymentState != paymentState.SUCCEEDED;
    },
    getFullNameUserHtml: getFullNameUserHtml,
    getOrderStatusLabel: getOrderStatusLabel,
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency
  }
};